import { render } from "./GestionSolicitudes.vue?vue&type=template&id=a1c4736c"
import script from "./GestionSolicitudes.vue?vue&type=script&lang=js"
export * from "./GestionSolicitudes.vue?vue&type=script&lang=js"

import "./GestionSolicitudes.vue?vue&type=style&index=0&id=a1c4736c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__